export default __webpack_public_path__ + "718c406998fee73ee9f335f4e02152be.svg";